import { useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { Overlay, Popover, Button, Offcanvas, Modal } from "react-bootstrap";

/* room5 서재 */

function Room5(){

  const location = useLocation();

  useEffect(() => {
  setOpenIndex(null);    // 페이지 이동하면 서랍 닫기
  setShowLetter(false);  // 편지 모달 닫기
}, [location.pathname]);

  const [showLetter, setShowLetter] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  const toggleDrawer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const drawers = [
    { title: '서랍', content: '첫 번째 칸. 잡동사니가 들어있다. 특별한 건 없어 보인다' },
    { title: '서랍', content: '가운데 칸. 달라붙어서 열리지 않는다. 열 필요는 없을 것 같다' },
    { title: '서랍', content: '세 번째 칸. 편지가 들어있다. 중요해 보이는데...' },
  ];

  const [showDeskPopover, setShowDeskPopover] = useState(false);
  const [DeskPopoverText, setDeskPopoverText] = useState('');
  const DeskRef = useRef(null);

  const handleDeskClick = () => {
  setDeskPopoverText("먼지가 쌓여있다");
  setShowDeskPopover(true);
  setTimeout(() => setShowDeskPopover(false), 2000);
  };

    return(
        <div 
        className={`d-flex justify-content-center align-content-center flex-wrap ${showLetter ? 'blur-background' : ''}` }
        style={{height: 'calc(100vh - 200px)',
        overflow: 'visible',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'flex-end',
        gap: '20px',
        marginTop: '-10vh',
        position: 'relative',
        pointerEvents: 'auto',
        zIndex: 1,
         }}>
          <div style={{ flexShrink: 0 }}>
        <button
          ref={DeskRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleDeskClick}
          style={{
            width: '30vw',
            height: '20vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >원목 책상</button>
          </div>
           
          {DeskRef.current && (
            <Overlay target={DeskRef.current} show={showDeskPopover} placement="top" style={{ zIndex: 1 }}>
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{DeskPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}

        <div className="align-items-center"
            style={{
            width: '18vw',
            display: 'flex',
            flexDirection: 'row',
            border: '1px solid lightgray',
            zIndex: 3,
          }}
        >
      {drawers.map((drawer, index) => (
  <div key={index}
        style={{
        position: 'relative', // 버튼과 배경을 겹치게 하기 위해 필요
        width: '6vw', // 총 18vw / 3개 = 6vw
        height: '8vh', // 버튼 높이와 동일하게
      }}>
        <div
        style={{
          backgroundColor: '#757575ff',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 0, // 버튼보다 뒤에 위치
        }}
      />
    <Button
      variant="secondary"
      onClick={() => toggleDrawer(index)}
      onMouseEnter={() => setHoverIndex(index)}
      onMouseLeave={() => setHoverIndex(null)}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 0,
        display: 'flex',                // 수평·수직 중앙 정렬을 위한 flex
        alignItems: 'center',           // 수직 중앙
        justifyContent: 'center',       // 수평 중앙
        textAlign: 'center',  
        height: '100%',
        overflow: 'hidden',
        transition: (index!==1)? 'transform 0.3s ease' : 'none',
        transform: (hoverIndex === index && index !== 1) ? 'translateY(10px)' : 'translateY(0)',
        backgroundColor: '#dee2e6',
        backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
        backgroundSize: '5px 5px',
        borderBottom: '1px solid #ccc',
        padding: '8px 12px',
        fontSize: '70%',
        zIndex: 2,
      }}
    >
      {drawer.title}
    </Button>

    <Offcanvas
      show={openIndex === index}
      onHide={() => setOpenIndex(null)}
      placement="bottom"
      backdrop={false}
      scroll={true}
      style={{ height: '20vh', backgroundColor:'#f1f1f1', zIndex: 1 }} // 높이 20%로 설정
    >
      <Offcanvas.Header closeButton>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ fontSize: '90%' }}>

      <div className="d-flex justify-content-between align-items-center">
      <span>{drawer.content}</span>
      {index === 2 && (
        <Button variant="outline-primary" size="sm" onClick={() => setShowLetter(true)}>
          ... 읽어볼까?
        </Button>
      )}
    </div>

      </Offcanvas.Body>
    </Offcanvas>
  </div>
      ))}
    </div>

      <Modal
      show={showLetter}
      onHide={() => setShowLetter(false)}
      backdrop={false}
      centered
    >
      <Modal.Header closeButton style={{ borderBottom: 'none' }}/>
      <Modal.Body>
        <p className="fst-italic text-muted">
          [... 우리 생각이다른 건 알고 있어. 그래도 난 네가 필요해.<br/> 
          아직 너와 안 해본게 많이있는 걸. <br/>
          너와 가고 싶은곳, 네게 보여 줄 것도 <br/>
          너무 많아.비밀이 지만, 다음번 기념일을 위해 <br/>
          준비해 둔 것도있어. 그러니까……]</p>
        <p className="text-end">... 여기까지만 읽어도 될 것 같다</p>
      </Modal.Body>
    </Modal>


    </div>
       );
}

export default Room5;

